
  $(document).ready(function(){ 
    var navHeight = $('.main-navigation').outerHeight();
    $('#MainContent').css('margin-top', navHeight + 'px');
  });


  /* Grid View */

document.addEventListener('DOMContentLoaded', () => {
  const grid = document.querySelector('#product-grid');
  const triggers = document.querySelectorAll('.view-trigger');

  if (!grid || !triggers.length) return;

  triggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const isGrid = trigger.classList.contains('grid-view');
      const isList = trigger.classList.contains('list-view');

      grid.classList.remove('grid-view', 'list-view');
      triggers.forEach(t => t.classList.remove('active'));

      if (isGrid) {
        grid.classList.add('grid-view');
      }

      if (isList) {
        grid.classList.add('list-view');
      }

      trigger.classList.add('active');
    });
  });
});

/* --------------------------
   UNIVERSAL ADD-TO-CART LISTENER
--------------------------- */
/* --------------------------
   CONFETTI BUTTON EFFECT
--------------------------- */

jQuery(function ($) {
  console.log("✅ Confetti system loaded");

  function buttonConfetti(btn) {

    const rect = btn.getBoundingClientRect();

    const xPos = (rect.left + rect.width / 2) / window.innerWidth;
    const yPos = (rect.top + rect.height / 2) / window.innerHeight;

    confetti({
      particleCount: 70,
      startVelocity: 30,
      spread: 60,
      scalar: 1,
      origin: { x: xPos, y: yPos },
      colors: ["#FFD700", "#d4af37", "#f5deb3"]
    });

    console.log("🎉 Confetti launched from button!");
  }

  // capture phase so Shopify / UpCart can't block it
  document.addEventListener("click", function (e) {

    const btn = e.target.closest('button[name="add"]');

    if (!btn) return;

    console.log("🟡 Add to cart clicked");

    buttonConfetti(btn);

  }, true);

});

/* --------------------------
   HOMEPAGE CONFETTI
--------------------------- */

document.addEventListener("DOMContentLoaded", function () {

  if (window.location.pathname !== "/" && window.location.pathname !== "/index") return;

  if (sessionStorage.getItem("homepage_confetti_shown")) return;
  sessionStorage.setItem("homepage_confetti_shown", "true");

  function burstLeft(y) {
    confetti({
      particleCount: 60,
      startVelocity: 40,
      spread: 75,
      origin: { x: 0.02, y: y },
      colors: ["#FFD700", "#d4af37", "#f5deb3"]
    });
  }

  function burstRight(y) {
    confetti({
      particleCount: 60,
      startVelocity: 40,
      spread: 75,
      origin: { x: 0.98, y: y },
      colors: ["#FFD700", "#d4af37", "#f5deb3"]
    });
  }

  setTimeout(() => {

    // first explosions
    burstLeft(0.65);
    burstRight(0.65);

    // second explosions
    setTimeout(() => {
      burstLeft(0.55);
      burstRight(0.55);
    }, 600);

  }, 700);

});